import type { SessionInfo } from '@/api/types';

/**
 * A dónde debe ir una sesión que aún no puede usar el panel (guarda de UX; la API autoriza igual). El orden importa:
 *  - segundo factor por VERIFICAR: primero eso (la API no deja ni cambiar la contraseña hasta verificar);
 *  - contraseña temporal pendiente: cambiarla;
 *  - segundo factor por ENROLAR (administrador de plataforma): después de la contraseña, activar el 2FA.
 */
export function sessionGate(session: Pick<SessionInfo, 'user' | 'mfa'>): '/two-factor' | '/change-password' | null {
  if (session.mfa.state === 'verify') return '/two-factor';
  if (session.user.mustChangePassword) return '/change-password';
  if (session.mfa.state === 'enroll') return '/two-factor';
  return null;
}
